import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { ASSETS } from "../lib/constants";

function LegalLayout({ title, children }) {
  return (
    <div className="grain min-h-screen relative">
      <nav className="relative z-20 flex items-center justify-between px-5 sm:px-10 py-5 border-b border-white/10">
        <Link to="/" className="flex items-center gap-3" data-testid="legal-home-link">
          <img src={ASSETS.logo} alt="TSG Sprockhövel" className="h-11 w-auto object-contain" />
          <span className="hidden sm:block text-[11px] tracking-[0.28em] uppercase text-[#9fb2cc]">Tippspiel</span>
        </Link>
        <Link to="/" className="btn-ghost text-xs px-4 py-2 flex items-center gap-2">
          <ArrowLeft size={13} /> Startseite
        </Link>
      </nav>

      <main className="relative z-10 max-w-3xl mx-auto px-5 sm:px-10 py-16 sm:py-24">
        <h1 className="font-head text-4xl sm:text-6xl uppercase tracking-tighter mb-10">{title}</h1>
        <div className="space-y-6 text-[#cbd5e1] leading-relaxed text-sm sm:text-base [&_h2]:font-head [&_h2]:uppercase [&_h2]:text-white [&_h2]:text-xl [&_h2]:tracking-tight [&_h2]:mt-8 [&_h2]:mb-1 [&_strong]:text-white">
          {children}
        </div>
      </main>

      <footer className="relative z-10 border-t border-white/10 px-5 sm:px-10 py-8">
        <p className="max-w-3xl mx-auto text-xs text-[#9fb2cc]">© {new Date().getFullYear()} TSG Sprockhövel · Tip-Battle</p>
      </footer>
    </div>
  );
}

export function Impressum() {
  return (
    <LegalLayout title="Impressum">
      <h2>Angaben gemäß § 5 TMG</h2>
      <p>
        <strong>Cengiz Kosan</strong><br />
        Im Unterdorf 6<br />
        45549 Sprockhövel
      </p>
      <h2>Kontakt</h2>
      <p>Für Rückfragen zum Tippspiel „Oberliga Westfalen Tip-Battle" wende dich bitte an die im Verein hinterlegten Kontaktwege der TSG Sprockhövel.</p>
      <h2>Verantwortlich für den Inhalt</h2>
      <p>Cengiz Kosan, Im Unterdorf 6, 45549 Sprockhövel</p>
      <h2>Haftung für Inhalte</h2>
      <p>Die Inhalte dieser Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.</p>
      <p className="text-xs text-[#9fb2cc] pt-4">Hinweis: Bitte lass die rechtlichen Texte vor dem Live-Gang durch eine fachkundige Person prüfen.</p>
    </LegalLayout>
  );
}

export function Datenschutz() {
  return (
    <LegalLayout title="Datenschutz">
      <p>Der Schutz deiner persönlichen Daten ist uns wichtig. Nachfolgend informieren wir dich über die Verarbeitung deiner Daten im Rahmen des Tippspiels „Oberliga Westfalen Tip-Battle".</p>
      <h2>Verantwortlicher</h2>
      <p>Cengiz Kosan, Im Unterdorf 6, 45549 Sprockhövel</p>
      <h2>Welche Daten wir erheben</h2>
      <p>Zur Teilnahme am Tippspiel erheben wir <strong>Vorname, Nachname, E-Mail-Adresse</strong> sowie deine abgegebenen <strong>Ergebnis-Tipps</strong>. Die Angabe erfolgt freiwillig, ist aber zur Teilnahme erforderlich.</p>
      <h2>Zweck der Verarbeitung</h2>
      <p>Die Daten werden ausschließlich zur Durchführung und Auswertung des Tippspiels sowie zur Ermittlung und Benachrichtigung von Gewinnern verwendet. Nach dem Absenden erhältst du eine Bestätigungs-E-Mail mit deinen Tipps.</p>
      <h2>Rechtsgrundlage</h2>
      <p>Die Verarbeitung erfolgt auf Grundlage deiner Einwilligung (Art. 6 Abs. 1 lit. a DSGVO), die du mit dem Setzen der Checkbox im Teilnahmeformular erteilst.</p>
      <h2>Speicherdauer</h2>
      <p>Die Daten werden nur so lange gespeichert, wie es für die Durchführung des Tippspiels erforderlich ist, und anschließend gelöscht.</p>
      <h2>Weitergabe an Dritte</h2>
      <p>Eine Weitergabe an Dritte erfolgt nicht. Für den E-Mail-Versand wird ein technischer Dienstleister eingesetzt, der die Daten ausschließlich weisungsgebunden verarbeitet.</p>
      <h2>Deine Rechte</h2>
      <p>Du hast das Recht auf Auskunft, Berichtigung, Löschung und Einschränkung der Verarbeitung sowie das Recht, deine Einwilligung jederzeit mit Wirkung für die Zukunft zu widerrufen.</p>
      <p className="text-xs text-[#9fb2cc] pt-4">Hinweis: Bitte lass die rechtlichen Texte vor dem Live-Gang durch eine fachkundige Person prüfen.</p>
    </LegalLayout>
  );
}

export function AGB() {
  return (
    <LegalLayout title="Teilnahmebedingungen & AGB">
      <h2>1. Veranstalter</h2>
      <p>Veranstalter des Tippspiels „Oberliga Westfalen Tip-Battle" ist Cengiz Kosan, Im Unterdorf 6, 45549 Sprockhövel, in Zusammenarbeit mit der TSG Sprockhövel.</p>
      <h2>2. Teilnahme</h2>
      <p>Teilnahmeberechtigt sind natürliche Personen. Die Teilnahme erfolgt durch Abgabe der Ergebnis-Tipps für alle Spiele des aktuellen Spieltags und Angabe der erforderlichen Daten im Teilnahmeformular. Die Teilnahme ist kostenlos.</p>
      <h2>3. Annahmeschluss</h2>
      <p>Tipps können nur bis zum angegebenen <strong>Annahmeschluss</strong> (in der Regel der Freitag vor dem jeweiligen Spieltag) abgegeben werden. Nach Ablauf der Frist ist keine Teilnahme mehr möglich.</p>
      <h2>4. Ermittlung des Gewinners</h2>
      <p>Es gewinnt, wer den Trainer schlägt, d. h. mehr richtige Ergebnisse tippt als der Trainer. Über die genaue Wertung entscheidet der Veranstalter. Bei mehreren Gewinnern kann das Los entscheiden.</p>
      <h2>5. Gewinn</h2>
      <p>Der jeweils ausgelobte Gewinn ist auf der Startseite angegeben. Eine Barauszahlung oder ein Umtausch des Gewinns ist nicht möglich.</p>
      <h2>6. Datenschutz</h2>
      <p>Die im Rahmen des Tippspiels erhobenen Daten werden gemäß unserer Datenschutzerklärung verarbeitet.</p>
      <h2>7. Sonstiges</h2>
      <p>Der Rechtsweg ist ausgeschlossen. Der Veranstalter behält sich vor, das Tippspiel bei Vorliegen wichtiger Gründe zu ändern, auszusetzen oder zu beenden.</p>
      <p className="text-xs text-[#9fb2cc] pt-4">Hinweis: Bitte lass die rechtlichen Texte vor dem Live-Gang durch eine fachkundige Person prüfen.</p>
    </LegalLayout>
  );
}
